import * as Yup from 'yup'
import { Constant } from '@utils'
export const imageInputSchema = Yup.lazy((value) => {
  if (typeof value === 'string') {
    return Yup.string()
      .matches(/^uploads\//, "Invalid path. Must start with 'uploads/'")
      .required('Invalid image')
  }

  return Yup.object().shape({
    base64: Yup.string().required('Image is required'),
    extension: Yup.string()
      .oneOf(
        Constant.imageValidationExtensions,
        `Extension must be one of: ${Constant.imageValidationExtensions.join(', ')}`,
      )
      .required('Invalid Extension'),
  })
})

export const imageNullInputSchema = Yup.lazy((value) => {
  if (typeof value === 'string') {
    return Yup.string()
      .matches(/^uploads\//, "Invalid path. Must start with 'uploads/'")
      .notRequired()
  }

  return Yup.object().shape({
    base64: Yup.string().notRequired(),
    extension: Yup.string()
      .oneOf(
        Constant.imageValidationExtensions,
        `Extension must be one of: ${Constant.imageValidationExtensions.join(', ')}`,
      )
      .notRequired(),
  })
})

export const csvInputSchema = Yup.lazy((value) => {
  if (typeof value === 'string') {
    return Yup.string().required('Invalid File')
  }

  return Yup.object().shape({
    base64: Yup.string().required('File is required'),
    extension: Yup.string()
      .oneOf(
        Constant.csvValidationExtension,
        `Extension must be one of: ${Constant.csvValidationExtension.join(', ')}`,
      )
      .required('Invalid Extension'),
  })
})
